import { memoize } from '@dbh/lodash-extra';

const THEME_KEY_INTL_FORM_FIELD="intlFormField";const modifyIntlFormFieldTheme=memoize(a=>{let{fonts:{style:{bold:e},size:{ff9:f}},spacing:{sp1:b,sp2:c},colors:{blackMid:d}}=a;return {[THEME_KEY_INTL_FORM_FIELD]:{label:{weight:e,padding:"0 0 "+c+" "+b,color:d,size:f}}}});

export { THEME_KEY_INTL_FORM_FIELD, modifyIntlFormFieldTheme as default };
